import moment from 'moment'
import { Timezone } from '@carsys/enums/timezone'

export const setTimezone = (timezone: Timezone) => {
  moment.tz.setDefault(timezone)
}
